<template>
  <template-layout :breadCrumbList="breadcrumbComputed">
    <div class="py-12 px-4">
      <nav class="sm:flex justify-between items-center mb-4">
            <div class="flex">
                <h1 class="text-2xl text-theme-1">
                รายงาน
                </h1>
                <button class="p-2 btn btn-outline-theme-36 rounded search-btn">
                  <!-- <FilterIcon @click="hideSearch" class="w-5 h-5" id="search_action"/> -->
                  <MenuIcon @click="hideSearch" class="w-5 h-5" id="search_action"/>
                </button>
            </div>
            <div v-if="!getAllowActionByCurrRole('disabled-report-export')">
              <span class="mr-1">นำออกข้อมูล</span>
              <button class="btn btn btn-outline-secondary rounded bg-white mr-1" @click="downloadCsv = true">csv</button>
              <button class="btn btn btn-outline-secondary rounded bg-white" @click="downloadExcel = true">Excel</button>
            </div>
      </nav>
      <div class="grid grid-cols-12 gap-6">
        <div class="col-span-12 md:col-span-4 lg:col-span-3" id="search">
          <ReportFilter />
        </div>
        <div class="col-span-12 md:col-span-8 lg:col-span-9" id="main_content">
          <FilterSummary :items="filterSummaryStore" />
          <Datatable :filter="filterValue" :downloadCsv="downloadCsv" @downloadCsvComplete="downloadCsv = false" :downloadExcel="downloadExcel" @downloadExcelComplete="downloadExcel = false"/>
        </div>
      </div>
    </div>
  </template-layout>
</template>

<script setup>
import ReportFilter from "@/components/filter-search/ReportFilter.vue";
import FilterSummary from "@/components/filter-summary/index.vue";
import Datatable from "./Datatable.vue"
import { computed, reactive, ref } from "vue";
import TemplateLayout from "@/layouts/side-menu/Main.vue"
import { useStore } from "vuex";
import { getAllowActionByCurrRole } from "@/utils/get-roles"

const store = useStore();
const filterSummaryStore = computed(
  () => store.getters["reportFilter/getFilterSummaryArray"]
);
const filterValue = computed(() => store.getters["reportFilter/getFilterForApi"]);
const breadcrumbComputed = reactive([{
  name: "รายงานสรุปผลการจัดทำข้อมูล",
  active: true
}])
const hideSearch = () => {

    const search_action = document.getElementById("search_action")
    search_action.classList.toggle("hide")
    const search = document.getElementById("search")
    const content = document.getElementById("main_content")
    if(search_action.classList.contains("hide")){
        // search_action.innerHTML = "แสดงการค้นหา"
        search.style.display="none"
        content.classList.remove("lg:col-span-9","md:col-span-8")
        content.classList.add("lg:col-span-12","md:col-span-12")
    }
    else{
        // search_action.innerHTML = "ซ่อนการค้นหา"
        search.style.display="block"
        content.classList.remove("lg:col-span-12","md:col-span-12")
        content.classList.add("lg:col-span-9","md:col-span-8")
    }

}
const downloadCsv = ref(false)
const downloadExcel = ref(false)

</script>
<style lang="scss">
.tabulator {
  .tabulator-headers{
    background:#214181;
    color: #FFF;
    font-weight: bold;
  }
}
.search-btn{
    border: 0;
    background: transparent;
    box-shadow: unset !important;
    &:focus{
        outline: 0;
        box-shadow: 0;
    }
}
</style>
